<template>
  <section class="list">
    <div
      class="list__headers row"
      :class="[
        type === 'client' ? 'row_clients' : 'row_products',
        { 'row_clients--hubspot': type === 'client' && hasHubspotIntegration },
      ]"
    >
      <span class="list__header" />

      <span class="list__header">
        Cabecera
        <a-tooltip>
          <template #title>
            <span>
              Es el encabezado de las columnas en tu plantilla excel. Definen la información que irá
              en dicha columna.
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span class="list__header">
        Nombre de columna
        <a-tooltip>
          <template #title>
            <span>Nombre de la columna que visualizarán en {{ ProductName }} tus usuarios. </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span class="list__header" v-if="type == 'client' && hasHubspotIntegration">
        Columna de Hubspot
        <a-tooltip>
          <template #title>
            <span>
              Homologa las columnas de HubSpot con su equivalente en BeexCC. Solo se exportarán o importarán las columnas que estén homologadas.
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span class="list__header" v-if="type == 'client'">
        Dato requerido
        <a-tooltip>
          <template #title>
            <span>
              Si seleccionas el checkbox, los datos serán requeridos en las carga masivas y manuales de nuevos contactos.
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span v-if="type === 'product'" class="list__header">
        Para reporte y callback
        <a-tooltip>
          <template #title>
            <span>
              Descarga hasta 10 de estos campos en en el reporte “Tipificaciones por contacto”,
              además seran compartidos por el callback de “Actualización de datos generales y
              personalizados de contacto”.
              <!-- Incluye hasta 10 campos en el reporte “Tipificaciones por
              contacto” al descargarlo, seleccionando la casilla correspondiente. -->
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span v-if="type === 'client'" class="list__header">
        Para reporte
        <a-tooltip>
          <template #title>
            <span>
              Indica los campos que se incluirán en el reporte “Tipificaciones por contacto”. 
              <strong>Máximo 14 campos.</strong>
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span v-if="type === 'client'" class="list__header">
        Para callback
        <a-tooltip>
          <template #title>
            <span>
              Indica los campos que se enviarán por el callback "Actualización de datos personales y personalizados de contacto". 
              <strong>Máximo 45 campos.</strong>
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span v-if="type === 'client'" class="list__header">
        Requerido en leads por API
        <a-tooltip>
          <template #title>
            <span>
              Los datos seleccionados se cargarán automáticamente en la plataforma desde la API
              conectada. El código de contacto determinará si se crea un nuevo registro o se
              actualiza uno existente.
              <!-- Incluye hasta 10 campos en el Lead -->
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span class="list__header">
        Ver en workspace
        <a-tooltip>
          <template #title>
            <span>
              Elige si este campo será visible para tus usuarios en la información del contacto en
              {{ ProductName }}, seleccionando la casilla correspondiente.
            </span>
          </template>
          <InfoCircleOutlined class="tooltip" />
        </a-tooltip>
      </span>

      <span class="list__header">Acciones</span>
    </div>

    <!-- <CustomScrollbar height="calc(100vh - 400px)"> -->
    <div class="scroll__wrapper">
      <draggable
        v-model="activesList"
        handle=".row__drag"
        item-key="element.name"
        :move="checkMove"
      >
        <template #item="{ element, index }">
          <HeadersItem
            :key="element.name"
            :item="element"
            :index="index"
            class="row"
            :class="[
              type === 'client' ? 'row_clients' : 'row_products',
              { 'row_clients--hubspot': type === 'client' && hasHubspotIntegration },
            ]"
            :templateName="templateName"
            :propertiesContactHubspot="propertiesContactHubspot"
            :hasHubspotIntegration="hasHubspotIntegration"
            :usedHubspotProperties="usedHubspotProperties"
          />
        </template>
      </draggable>
    </div>
    <!-- </CustomScrollbar> -->
  </section>
</template>

<script>
// import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import HeadersItem from "@/app/imports/components/lists/HeadersItem.vue";
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import draggable from "vuedraggable";
import { SET_ACTIVE_FIELDS } from "@/app/imports/store/templates/mutation-types";
import { ProductName } from "@/app/shared/utils/constants";
import { fetchContactPropertiesHubspot } from "../../services";
import httpManager from "@/app/shared/utils/httpManager";
import { StatusHubpspot } from "@/@types/integrations";

export default defineComponent({
  components: {
    // CustomScrollbar,
    HeadersItem,
    InfoCircleOutlined,
    draggable,
  },
  props: {
    templateName: {
      required: true,
      type: String,
    },
    type: String,
  },
  data() {
    return {
      nameDeleteList: [],
      ProductName,
      propertiesContactHubspot: [],
      // activesList: this.$store.getters["getActiveTemplateFieldsOrdered"],
    };
  },
  computed: {
    // actives() {
    //   return this.$store.getters["getActiveTemplateFieldsOrdered"];
    // },
    activesList: {
      get() {
        return this.$store.getters["getActiveTemplateFieldsOrdered"];
      },
      set(newList) {
        this.$store.commit(SET_ACTIVE_FIELDS, newList);
      },
    },
    hasHubspotIntegration() {
      return this.$store.getters["getDataUser"]?.customer?.hubspot_status == StatusHubpspot.Integrated;
    },
    usedHubspotProperties() {
      return this.activesList
        .map(item => item.hubspot_property)
        .filter(Boolean)
    }
    // disabled() {
    //   return this.actives.
    // }
  },
  // watch: {
  //   activesList(newList) {
  //     this.$store.commit(SET_ACTIVE_FIELDS, newList);
  //   },
  //   actives(newActivities) {
  //     console.log(newActivities);
  //     this.activesList = newActivities;
  //   },
  // },
  methods: {
    handleDeleteItem(e) {
      this.nameDeleteList.push(e.name);
    },
    checkMove(e) {
      const staticFieldsLength = this.activesList.filter((e) => !e.editable).length;
      if (e.draggedContext.futureIndex < staticFieldsLength) return false;

      const futureItem = this.activesList[e.draggedContext.futureIndex];
      return !futureItem.disabled;
    },
    async getContactPropertiesHubspot() {
      const response = await fetchContactPropertiesHubspot();
      this.propertiesContactHubspot = response?.optional || [];
    },
  },
  async created() {
    if (this.hasHubspotIntegration)
      await this.getContactPropertiesHubspot();
  },
});
</script>

<style lang="sass" scoped>
.row
  display: grid
  // grid-template-columns: 24px 160px 200px 140px 200px 230px 160px 85px
  &_clients
    grid-template-columns: 24px 160px 214px 144px 120px 128px 220px 160px 88px

    &--hubspot
      grid-template-columns: 24px 160px 214px 200px 144px 120px 128px 220px 160px 88px

  &_products
    grid-template-columns: 24px 160px 200px 200px 200px 160px 85px

.list
  color: $gray-9
  margin-right: 20px

  &__header
    background-color: $gray-2
    padding: 8px
    font-weight: 600
    .strong
      font-weight: 600

.tooltip
  margin-left: 6px

.scroll__wrapper
  max-height: calc(100vh - 400px)
  overflow-y: auto
</style>
